import React from 'react';
import { KeyRound, Lock } from 'lucide-react';
import { useAccess } from '../../contexts/AccessContext';

/** Friendly locked-content card with a one-tap unlock button. */
export const LockedNotice = ({
  title = 'Continue with your email to see this',
  body = 'No password needed — just your email once, and this opens up along with the rest of the library.',
  compact = false,
  className = '',
  testid = 'locked-notice',
}) => {
  const { openPrompt, demoted } = useAccess();
  return (
    <div
      className={`rounded-2xl border border-[#e5c976]/50 bg-gradient-to-br from-[#fbf7ee] to-[#f3ead2] ${compact ? 'p-4' : 'p-6 sm:p-8'} text-left ${className}`}
      data-testid={testid}
    >
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 rounded-xl bg-[#0f1729] flex items-center justify-center shrink-0">
          <Lock className="w-4 h-4 text-[#e5c976]" />
        </span>
        <div className="min-w-0 flex-1">
          <h3 className={`font-bold text-[#0f1729] ${compact ? 'text-sm' : 'text-base md:text-lg'}`}>{title}</h3>
          <p className="text-sm text-[#4b5563] mt-1 leading-relaxed">
            {demoted ? 'Your account currently has the open library only. Please reach out to us to have the full Otzar restored.' : body}
          </p>
          {!demoted && (
            <button
              type="button"
              onClick={openPrompt}
              className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold text-white bg-gradient-to-b from-[#c9a437] to-[#8c691b] hover:from-[#e5c976] hover:to-[#9a7523] shadow-[0_6px_16px_-6px_rgba(154,123,36,0.8)] transition-all"
              data-testid={`${testid}-unlock`}
            >
              <KeyRound className="w-4 h-4" /> Continue with my email
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

/** Route wrapper: renders children for members, a locked page for guests. */
export const FullTierRoute = ({ children, title, body }) => {
  const { loading, isGuest } = useAccess();
  if (loading) return null;
  if (!isGuest) return children;
  return (
    <div className="min-h-screen bg-background flex items-start justify-center p-4 pt-16 sm:pt-24" data-testid="full-tier-route-locked">
      <div className="w-full max-w-xl">
        <LockedNotice title={title} body={body} testid="full-tier-locked" />
      </div>
    </div>
  );
};

export default LockedNotice;
